export const cs2Constants = {
    

    EXECUTIONS_REQUEST: 'BASKET_EXECUTIONS_REQUEST',
    EXECUTIONS_SUCCESS: 'BASKET_EXECUTIONS_SUCCESS',
    EXECUTIONS_FAILURE: 'BASKET_EXECUTIONS_FAILURE',
    
    FILE_SUBMISSION_REQUEST: 'FILE_SUBMISSION_REQUEST',
    FILE_SUBMISSION_SUCCESS: 'FILE_SUBMISSION_SUCCESS',
    FILE_SUBMISSION_FAILURE: 'FILE_SUBMISSION_FAILURE',
    
    SUBMISSION_LOG_REQUEST: 'SUBMISSION_LOG_REQUEST',
    SUBMISSION_LOG_SUCCESS: 'SUBMISSION_LOG_SUCCESS',
    SUBMISSION_LOG_FAILURE: 'SUBMISSION_LOG_FAILURE',
    
    FIRM_GROUP_REQUEST: 'FIRM_GROUP_REQUEST',
    FIRM_GROUP_SUCCESS: 'FIRM_GROUP_SUCCESS',
    FIRM_GROUP_FAILURE: 'FIRM_GROUP_FAILURE',
    
    // DB_CS2_SPECS: 'DB_CS2_SPECS',
    
    // DB_DMMEC_ADMIN: 'DB_DMMEC_ADMIN',
    // DB_DMMEC_USERS: 'DB_DMMEC_USERS',
    
    // DB_NEW_RULE134_ADMIN: 'DB_New_Rule134Admin',
    // DB_NEW_RULE134_USERS: 'DB_New_Rule134Users',
    
    // DB_WEB_CS2PLUS_USERS: 'DB_WEB_CS2PLUS_USERS',
    	
    // DB_CS2PLUS_USERS_LEGACY: 'DB_CS2PlusUsers'
};
